var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#3889FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0897 17.5629C14.9941 17.5629 17.6774 13.4986 17.6774 9.97515C17.6774 9.8609 17.6749 9.7441 17.6698 9.62984C18.1918 9.25235 18.6422 8.78478 19 8.2491C18.5139 8.46539 17.9977 8.60665 17.4692 8.66805C18.0257 8.33447 18.4424 7.81044 18.642 7.1931C18.1185 7.50337 17.5459 7.72223 16.9489 7.84031C16.5467 7.41291 16.0149 7.12992 15.4357 7.03509C14.8565 6.94026 14.2621 7.03888 13.7446 7.3157C13.2271 7.59252 12.8151 8.03211 12.5725 8.56652C12.3299 9.10094 12.27 9.7004 12.4022 10.2722C11.3422 10.219 10.3051 9.94365 9.35832 9.46395C8.41151 8.98425 7.57608 8.31092 6.90619 7.48764C6.56572 8.07465 6.46153 8.76929 6.61481 9.43036C6.76809 10.0914 7.16733 10.6693 7.73139 11.0466C7.30792 11.0332 6.89374 10.9192 6.52305 10.714V10.747C6.52267 11.3631 6.73564 11.9602 7.12575 12.437C7.51587 12.9137 8.05905 13.2407 8.66297 13.3623C8.2707 13.4696 7.85899 13.4852 7.45971 13.408C7.63012 13.9378 7.96169 14.4011 8.40813 14.7334C8.85457 15.0657 9.39361 15.2503 9.95002 15.2615C9.0054 16.0035 7.83851 16.406 6.6373 16.4041C6.42428 16.4037 6.21147 16.3907 6 16.365C7.2203 17.1478 8.63983 17.5636 10.0897 17.5629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlue);
export default __webpack_public_path__ + "static/media/twitter-blue.7509f1f3.svg";
export { ForwardRef as ReactComponent };